export default {
    //双11活动倒计时
    activity_count_down: "client/activity/skipAuth/activity/count/down",
    //双11免单订单列表
    activity_getFreeOrderList: "client/activity/skipAuth/double/prize/roll",
};
